// extracted by mini-css-extract-plugin
module.exports =  {"legacyScroll":"C_MOyoio0tezLFREdqlR","deleteButton":"Yk8OXR6jEUMoD_QdjYPN","leftActions":"NpfO2kffl1KXG06xk3gn","lastSaved":"NHt18hqAH2KTSFIE13CB"};